export const mixpanelConfig = {
    token: import.meta.env.REACT_APP_MIXPANEL_TOKEN
}
